import styled from 'styled-components'

export const Container = styled.div`
  padding: 2rem;
`

export const Section = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  margin-top: 50px;
  @media screen and (max-width: 900px) {
    flex-direction: column;
  }
`
